import { CalendarRange } from "lucide-react";

type SyncWindowCalloutProps = {
  /** UTC timestamps; formatted in the browser's timezone for display. */
  start: string | null;
  end: string | null;
};

const dateFormatter = new Intl.DateTimeFormat(undefined, {
  day: "numeric", month: "long", year: "numeric",
});

/**
 * The window the background sync currently watches for newly created calendar
 * appointments. Hidden until the sync has run once and reported a window.
 */
export const SyncWindowCallout = ({ start, end }: SyncWindowCalloutProps) => {
  if (!start || !end) return null;

  return (
    <div className="flex gap-3 rounded border border-blue-400 bg-blue-50 p-3.5 text-blue-900">
      <CalendarRange className="mt-0.5 size-4 shrink-0 text-blue-600" aria-hidden />
      <div className="text-sm">
        <p className="m-0">
          New calendar appointments are picked up between{" "}
          <span className="font-semibold">{dateFormatter.format(new Date(start))}</span> and{" "}
          <span className="font-semibold">{dateFormatter.format(new Date(end))}</span>.
        </p>
        <p className="m-0 mt-1 text-xs text-blue-900/70">
          This range moves forward on its own - there's nothing to renew.
        </p>
      </div>
    </div>
  );
};
